export default __webpack_public_path__ + "static/media/collections_8.85aa07e6.jpg";